////
/// @group Components
////

// import gsap from 'gsap'
import { breakpoints } from 'utility/helpers'

let lastWindowHeight = 0

export interface INavigation {
  /** @description Elements */
  el: {
    allNavigationLinks: NodeListOf<HTMLElement>
    header: HTMLElement
    mainList: HTMLElement
    wrapper: HTMLElement
    menu: HTMLElement
    languageButton: HTMLElement
    myPagesButton: HTMLElement
    trigger: HTMLElement
    backTriggers: NodeListOf<HTMLElement>
    forwardTriggers: NodeListOf<HTMLElement>
    hamburger: HTMLElement
  }

  /** @description Init method */
  init: () => void

  /**  @description Forward clicks */
  handleMobileNavigationLevels: () => void

  /**  @description Back clicks */
  hideMobileNavigation: () => void

  /**  @description Resets and hides mobile navigation */
  hideMobileNavigationOnResize: () => void

  /**  @description Shows mobile nav on. */
  showMobileNavigation: () => void

  /**  @description Show and hide */
  toggleMobileNavigation: () => void

  /**  @description Open and close */
  toggleSelected: (HTMLElement) => void

  /** @description Checks if able to scroll and shows shadow depending */
  checkForScroll: () => void

  /** @description Check screensize and modify mypages button*/
  handleMyPagesButton: () => void

  /** @description Check screensize and modify language button */
  handleLanguageButton: () => void
}

const MobileNavigation: INavigation = {
  el: {
    allNavigationLinks: document.querySelectorAll('.navigation-mobile__link') as NodeListOf<HTMLElement>,
    header: document.querySelector('.header-trigger'),
    wrapper: document.querySelector('.header__wrap'),
    mainList: document.querySelector('.navigation-mobile > .navigation-mobile__list'),
    trigger: document.querySelector('.hamburger-trigger'),
    backTriggers: document.querySelectorAll('.navigation-mobile-backward-trigger') as NodeListOf<HTMLElement>,
    forwardTriggers: document.querySelectorAll('.navigation-mobile-forward-trigger') as NodeListOf<HTMLElement>,
    menu: document.querySelector('.mobile-menu'),
    myPagesButton: document.querySelector('.header__links--mypages'),
    languageButton: document.querySelector('.header__links--language'),
    hamburger: document.querySelector('.hamburger'),
  },

  init() {
    MobileNavigation.hideMobileNavigation()
    window.addEventListener('resize', MobileNavigation.hideMobileNavigationOnResize)

    MobileNavigation.handleMyPagesButton()
    window.addEventListener('resize', MobileNavigation.handleMyPagesButton)

    MobileNavigation.handleLanguageButton()
    window.addEventListener('resize', MobileNavigation.handleLanguageButton)


    if (MobileNavigation.el.trigger) {
      MobileNavigation.el.trigger.addEventListener('click', MobileNavigation.toggleMobileNavigation)
    }
    MobileNavigation.handleMobileNavigationLevels()
    MobileNavigation.checkForScroll()

  },

  handleMyPagesButton() {
    const currentWidth = window.innerWidth
    if (currentWidth >= 1200) {
      MobileNavigation.el.myPagesButton.classList.add('button--square')
    } else {
      MobileNavigation.el.myPagesButton.classList.remove('button--square')
    }
  },

  handleLanguageButton() {
    const text = MobileNavigation.el.languageButton.querySelector('.button__text')
    const currentWidth = window.innerWidth
    if (currentWidth >= 1200) {
      MobileNavigation.el.languageButton.classList.add('button--square')
      MobileNavigation.el.languageButton.classList.remove('button--border-primary')
      MobileNavigation.el.languageButton.classList.remove('button--compact')
      text.textContent = MobileNavigation.el.languageButton.title
    } else {
      MobileNavigation.el.languageButton.classList.remove('button--square')
      MobileNavigation.el.languageButton.classList.add('button--border-primary')
      MobileNavigation.el.languageButton.classList.add('button--compact')

      let ariaLabel = MobileNavigation.el.languageButton.ariaLabel
      const label = ariaLabel.charAt(0).toUpperCase() + ariaLabel.slice(1);
      text.textContent = label
    }
  },

  checkForScroll() {
    const wrap = document.querySelector('.header__wrap')
    if (!wrap) return
    const hasVerticalScrollbar = wrap.scrollHeight > wrap.clientHeight;

    if (hasVerticalScrollbar) {
      MobileNavigation.el.menu.classList.add('mobile-menu--shadow')
    } else {
      MobileNavigation.el.menu.classList.remove('mobile-menu--shadow')
    }
  },



  handleMobileNavigationLevels() {
    MobileNavigation.el.forwardTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (window.innerWidth < breakpoints.desktopM) {
          //* parent ul child items
          const currentItems = Array.from(trigger.closest('.navigation-mobile__list').children)

          //* the ul you want to open
          const activeList = trigger.nextElementSibling

          //* parent li item
          const activeCurrentItem = trigger.parentElement

          //* child li items
          const activeItems = Array.from(trigger.nextElementSibling.children)
          console.log(activeItems + "activeItems")
          activeItems.forEach((item) => item.classList.remove('navigation-mobile__item--hidden'))

          //* mobile__link item
          const link = trigger.previousElementSibling

          activeList.classList.add('navigation-mobile__list--active')
          activeCurrentItem.classList.add('navigation-mobile__item--active')
          trigger.classList.add('navigation-mobile__link--hidden')

          if (link) {
            link.classList.add('navigation-mobile__link--hidden')
          }

          currentItems.forEach((item) => {
            item.classList.remove('navigation-mobile__item--hidden')

            if (!item.classList.contains('navigation-mobile__item--active'))
              item.classList.add('navigation-mobile__item--hidden')
          })

          MobileNavigation.checkForScroll()
          event.preventDefault()
        }
      })
    })

    MobileNavigation.el.backTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const currentList = trigger.closest('.navigation-mobile__list')
        const currentItem = currentList.parentElement
        const currentLink = currentItem.querySelector('.navigation-mobile__link')
        const parentItems = Array.from(currentItem.parentElement.children)
        const currentLinkButton = currentList.previousElementSibling

        currentList.classList.remove('navigation-mobile__list--active')
        currentItem.classList.remove('navigation-mobile__item--active')
        currentLink.classList.remove('navigation-mobile__link--hidden')
        currentLinkButton.classList.remove('navigation-mobile__link--hidden')

        parentItems.forEach((item) => item.classList.remove('navigation-mobile__item--hidden'))

        MobileNavigation.checkForScroll()
        event.preventDefault()
      })
    })
  },

  hideMobileNavigation() {
    document.documentElement.classList.remove('h--disable-scroll')
    MobileNavigation.el.header.classList.remove('header--navigation-active')
    MobileNavigation.el.hamburger.classList.remove('open')

    if (!MobileNavigation.el.mainList) return // last minute hack for en/pl versions with no navigation
  },

  hideMobileNavigationOnResize() {
    const currentHeight = window.innerHeight
    const verticalResize = currentHeight !== lastWindowHeight
    lastWindowHeight = currentHeight

    if (!verticalResize) MobileNavigation.hideMobileNavigation()
  },

  showMobileNavigation() {
    document.documentElement.classList.add('h--disable-scroll')
    MobileNavigation.el.header.classList.add('header--navigation-active')
    MobileNavigation.el.hamburger.classList.add('open')

    MobileNavigation.checkForScroll()
  },

  toggleMobileNavigation() {
    if (!MobileNavigation.el.header.classList.contains('header--navigation-active')) {
      MobileNavigation.showMobileNavigation()
    } else {
      MobileNavigation.hideMobileNavigation()
    }
  },

  toggleSelected(link) {
    if (!MobileNavigation.el.mainList) return // last minute hack for en/pl versions with no navigation

    const currentItem = MobileNavigation.el.mainList.querySelector('.navigation-mobile__item--selected')
    const selectedItem = link.closest('.navigation-mobile__item')

    if (currentItem) currentItem.classList.add('navigation-mobile__item--unselected')
    if (selectedItem) selectedItem.classList.add('navigation-mobile__item--selected')
  },
}

export default MobileNavigation
